import { StyledContainer as Container } from '../Container/container.styles';
import styled from 'styled-components';

export const StyledContainer = styled(Container)`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
`;
